module.exports = __webpack_public_path__ + "media/images/metronic/portlet-config-icon-white-121a7db8bfb29848d186f98c3d116df0.png";